import os from 'os';
import {
  getErrorScreenPath,
  numberingInquiryCode,
} from '@doda/common/src/logics/error';

/**
 * サーバーエラー画面への遷移
 * @param {string} message エラーメッセージ
 */
export const moveToServerErrorPage = (message: string) => {
  const serverHostName = os.hostname();
  const errorCode = numberingInquiryCode(serverHostName);
  window.DD_LOGS?.logger.error(`${message}、errorCode: ${errorCode}`);
  window.location.href = getErrorScreenPath(errorCode);
};
